var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{ref:"pagelist",attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions,"expandConfig":_vm.expandConfig},on:{"refresh":_vm.setNavbarAlert}})
}
var staticRenderFns = []

export { render, staticRenderFns }